import React, { useCallback, useState } from 'react';
import { Modal } from 'antd';
import Cropper from 'react-easy-crop'

export const CustomModal = ({
    isOpen,
    onClose,
    title,
    width = 520,
    centered = true,
    children,
    footer = null,
    className = "",
    closeIcon = true,
    maskClosable = true,
    modalType = "default", // Can be 'default', 'success', 'warning', 'error'
}) => {
    // Modal type styles
    const modalStyles = {
        default: "",
        success: "custom-modal-success",
        warning: "custom-modal-warning",
        error: "custom-modal-error"
    };

    return (
        <Modal
            title={title}
            open={isOpen}
            onCancel={onClose}
            centered={centered}
            width={width}
            footer={footer}
            className={`custom-modal ${modalStyles[modalType]} ${className}`}
            closeIcon={closeIcon}
            maskClosable={maskClosable}
        >
            {children}
        </Modal>
    );
};

export const ImageCropper = () => {
    const [crop, setCrop] = useState({ x: 0, y: 0 });
    const [zoom, setZoom] = useState(1);
    const [croppedAreaPixels, setCroppedAreaPixels] = useState(null);
    const [croppedImage, setCroppedImage] = useState(null);
    const [imageSrc, setImageSrc] = useState(null); // Store selected image source

    // Function to handle file input
    const onFileChange = (e) => {
        if (e.target.files && e.target.files.length > 0) {
            const reader = new FileReader();
            reader.readAsDataURL(e.target.files[0]);
            reader.onload = () => {
                setImageSrc(reader.result); // Set the image source from the uploaded file
            };
        }
    };

    const onCropComplete = useCallback((croppedArea, croppedAreaPixels) => {
        setCroppedAreaPixels(croppedAreaPixels);
    }, []);

    const getCroppedImg = (imageSrc, croppedAreaPixels) => {
        const createImage = (url) =>
            new Promise((resolve, reject) => {
                const image = new Image();
                image.src = url;
                image.onload = () => resolve(image);
                image.onerror = (error) => reject(error);
            });

        return createImage(imageSrc).then((image) => {
            const canvas = document.createElement('canvas');
            const ctx = canvas.getContext('2d');

            canvas.width = croppedAreaPixels.width;
            canvas.height = croppedAreaPixels.height;

            ctx.drawImage(
                image,
                croppedAreaPixels.x,
                croppedAreaPixels.y,
                croppedAreaPixels.width,
                croppedAreaPixels.height,
                0,
                0,
                croppedAreaPixels.width,
                croppedAreaPixels.height
            );

            return new Promise((resolve) => {
                canvas.toBlob((blob) => {
                    resolve(URL.createObjectURL(blob));
                }, 'image/jpeg');
            });
        });
    };

    const showCroppedImage = useCallback(async () => {
        try {
            const croppedImg = await getCroppedImg(imageSrc, croppedAreaPixels);
            setCroppedImage(croppedImg);
        } catch (e) {
            console.error(e);
        }
    }, [croppedAreaPixels, imageSrc]);

    return (
        <>
            <p>Image Crop</p>
            <div className="file-input">
                <input type="file" accept="image/*" onChange={onFileChange} />
            </div>

            {imageSrc ? (
                <>
                    <div className="crop-container" style={{ position: 'relative', width: '100%', height: '400px', maxWidth: '500px', marginBottom: '20px' }}>
                        <Cropper
                            image={imageSrc}
                            crop={crop}
                            zoom={zoom}
                            aspect={4 / 3}
                            onCropChange={setCrop}
                            onCropComplete={onCropComplete}
                            onZoomChange={setZoom}
                        />
                    </div>
                    <div className="control">
                        <input
                            type="range"
                            value={zoom}
                            min={1}
                            max={3}
                            step={0.1}
                            onChange={(e) => setZoom(e.target.value)}
                        />
                    </div>
                    <button onClick={showCroppedImage}>Crop Image</button>
                </>
            ) : (
                <p>Please upload an image to crop.</p>
            )}

            {croppedImage && (
                <div>
                    <h3>Cropped Image Preview</h3>
                    <img src={croppedImage} alt="Cropped" />
                </div>
            )}
        </>
    );
};

export const MemberShipCardStructure = ({CardWrapper , membershipCardContainer,heightContainer ,isMemberLogin}) => {
    return (
        
        <div className={`${membershipCardContainer}`}>    
        
    <div className={`flex items-center justify-center  ${heightContainer}`}>

    {/* <div className="membership-card-wrapper {}"> */}
    <div className={`membership-card-wrapper  ${CardWrapper}`}>
      {/* <img src="assets/family-fun-membership-card.png" alt=" " /> */}
      <div className="member-name-container flexbox justify-center flex-col h-full">
        <p className="font-bold text-md pt-[10px]">
          {/* {name} */}
        </p>
        {/* <p className="text-xs">{userInfo.email}</p> */}
      </div>
      <div className="flexbox w-full max-w[90%] justify-between px-[15px] py-[5px]">
        {isMemberLogin !== undefined &&(<>
        <p className='member-login-details'>
            {isMemberLogin}
        </p>
        </>)}
        <span className="font-semibold text-center">
          {/* <p className="text-sm family-fun-member-card-member-details">Status</p> */}
          <p className="text-xs text-green-600"></p>
        </span>
        <span className="font-semibold text-center">
          {/* <p className="text-sm">Expiry Date</p> */}
          <p className="text-xs">
            {/* {new Date(planExpirationDate).toLocaleDateString(
              "en-US",
              {
                month: "2-digit",
                day: "2-digit",
                year: "numeric",
              }
            )} */}
          </p>
        </span>
      </div>
    </div>
    </div>
    </div>
    )
}
